export default "<img src=\"../../assets/img/LoadBar.gif\" />\n"